import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "cy-notice-id title" };
const _hoisted_4 = {
    key: 0,
    class: "mr-2 brg-color-red-700"
};
const _hoisted_5 = { class: "option-ctrl-area" };
const _hoisted_6 = { class: "pb-3" };
const _hoisted_7 = { class: "pt-3 text-body wh-pl" };
import { computed, onMounted, onUnmounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
import CardSection from '@/components/Common/CardSection.vue';
import { storeToRefs } from 'pinia';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import AxiosResponse from '@/error/AxiosResponse';
import { isTodayTextColor, formatDate, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import { autoLcStoreWorkProcess } from '@/locales/ko/views/store_work_process';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { pStore } from '@/pinia';
import { BusinessError } from '@/error';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 총판점 공지사항 상세 조회
        const lc = autoLcStoreWorkProcess();
        const route = useRoute();
        const router = useRouter();
        const pStoreWorkProcess = pStore.piniaStoreWorkProcess;
        const { itemDetail } = storeToRefs(pStoreWorkProcess);
        const itemId = route.params.itemId;
        /** 답변 버튼 노출 여부 true: 노출, false: 숨김 */
        const isShowReplyBtn = computed(() => {
            // 내가 작성한 글이 아니고, 사용자가 작성한 글이면 답글 버튼 노출
            if (itemDetail.value.createdBy !== vuexStore.state.user.userInfo.userId
                && itemDetail.value.userType === 'USER') {
                return true;
            }
            return false;
        });
        const _confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        /**
         * 삭제 핸들러
         */
        const handleClickDeleteBtn = async () => {
            const isConfirmOk = await _confirm({
                headerTitle: i18n.t('common.confirm_before_delete_title'),
                bodyContent: i18n.t('common.confirm_before_delete'),
            });
            if (!isConfirmOk) {
                return;
            }
            try {
                await pStoreWorkProcess.deleteNotice(itemId);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.STORE_WORK_PROCESS,
                });
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = () => {
            router.push({
                name: routeName.STORE_WORK_PROCESS,
            }).catch(() => { });
        };
        /**
         * 수정 클릭 핸들러
         */
        const handleClickEditBtn = () => {
            const name = routeName.STORE_WORK_PROCESS_EDIT;
            const value = {
                params: {
                    itemId,
                },
                query: route.query,
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        /**
         * 답글 클릭 핸들러
         */
        const handleClickReplyBtn = () => {
            const name = routeName.STORE_WORK_PROCESS_CREATE_REPLY;
            const value = {
                params: {
                    itemId,
                },
                query: route.query,
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        /**
         * 삭제된 글이면 리턴 시킨다.
         */
        const checkIsDeleted = () => {
            if (itemDetail.value.isDeleted) {
                vuexStore.dispatch(snackbarActionType.showError);
                router.push({
                    name: routeName.STORE_WORK_PROCESS,
                });
            }
        };
        onMounted(async () => {
            try {
                await pStoreWorkProcess.getItem(itemId);
                checkIsDeleted();
                itemDetail.value.setIsMine(vuexStore.state.user.userInfo.userId);
            }
            catch (error) {
                console.log('error', error);
                if (error instanceof BusinessError) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
                if (error instanceof AxiosResponse) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
            }
        });
        onUnmounted(() => {
            pStoreWorkProcess.$reset();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                (_unref(itemDetail).isImportant)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_4, [
                                        _createVNode(_component_v_icon, {
                                            title: _unref(lc)('is_important')
                                        }, {
                                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                _createTextVNode(" mdi-alert-circle-outline ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [0]
                                        }, 8 /* PROPS */, ["title"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(lc)('is_important')), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(" " + _toDisplayString(_unref(itemDetail).title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["item body2-text", _unref(isTodayTextColor)(_unref(itemDetail).createdAt)]),
                                    title: "작성일자"
                                }, _toDisplayString(_unref(formatDate)(_unref(itemDetail).createdAt, _unref(dateFormatType).FULL_DATE_MINUTE)), 3 /* TEXT, CLASS */)
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(lc)('user_name')) + " : " + _toDisplayString(_unref(itemDetail).createdByHubName) + " / " + _toDisplayString(_unref(itemDetail).createdByName) + " (" + _toDisplayString(_unref(itemDetail).createdBy) + ") ", 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(itemDetail).body.replace(/<br>/g, "\r\n")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createCommentVNode(" footer "),
                _createVNode(BoardFooter, null, {
                    left: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    right: _withCtx(() => [
                        _createCommentVNode(" 삭제하기 "),
                        (_unref(itemDetail).isMine)
                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                onClick: handleClickDeleteBtn
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { small: "" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode(" mdi-trash-can-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [2]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('delete')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        danger: true,
                                        outlined: true,
                                        "size-l": true,
                                        "width-xs": true
                                    }
                                ]
                            ])
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 수정하기 "),
                        (_unref(itemDetail).isMine)
                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                class: "cy-edit-btn",
                                onClick: handleClickEditBtn
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { small: "" }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode(" mdi-pencil-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [3]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(lc)('edit')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "size-l": true,
                                        "width-xs": true
                                    }
                                ]
                            ])
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 답변하기 "),
                        (isShowReplyBtn.value)
                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 2,
                                onClick: handleClickReplyBtn,
                                class: "cy-reply-btn"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { small: "" }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode(" mdi-message-reply-text-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [4]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.reply')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        primary: true,
                                        "size-l": true,
                                        "width-xs": true
                                    }
                                ]
                            ])
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
